import { render, staticRenderFns } from "./KlantenIndex.vue?vue&type=template&id=d1d1edc6&scoped=true&"
import script from "./KlantenIndex.vue?vue&type=script&lang=js&"
export * from "./KlantenIndex.vue?vue&type=script&lang=js&"
import style0 from "./KlantenIndex.vue?vue&type=style&index=0&id=d1d1edc6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1d1edc6",
  null
  
)

export default component.exports